var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("导航")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('n3-nav', {
      attrs: {
        "default-active": _vm.activeIndex,
        "mode": "horizontal"
      },
      on: {
        "select": _vm.handleSelect
      }
    }, [_c('n3-nav-item', {
      attrs: {
        "index": "1"
      }
    }, [_vm._v("导航一")]), _vm._v(" "), _c('n3-sub-nav', {
      attrs: {
        "index": "2"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("导航二")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-1"
      }
    }, [_vm._v("选项1")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-2"
      }
    }, [_vm._v("选项2")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2-3"
      }
    }, [_vm._v("选项3")])], 2), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "3"
      }
    }, [_c('a', {
      attrs: {
        "href": "#",
        "target": "_blank"
      }
    }, [_vm._v("导航三")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('n3-nav', {
      style: ({
        width: '180px'
      }),
      attrs: {
        "default-active": "2",
        "theme": "dark"
      },
      on: {
        "open": _vm.handleOpen,
        "close": _vm.handleClose
      }
    }, [_c('n3-sub-nav', {
      attrs: {
        "index": "1"
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('n3-icon', {
      attrs: {
        "type": "bars"
      }
    }), _vm._v("导航一")], 1), _vm._v(" "), _c('n3-nav-group', {
      key: "1"
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("分组一")]), _vm._v(" "), _c('n3-nav-item', {
      key: "1-1",
      attrs: {
        "index": "1-1"
      }
    }, [_vm._v("选项1")]), _vm._v(" "), _c('n3-nav-item', {
      key: "1-2",
      attrs: {
        "index": "1-2"
      }
    }, [_vm._v("选项2")])], 2), _vm._v(" "), _c('n3-nav-group', {
      key: "2",
      attrs: {
        "title": "分组2"
      }
    }, [_c('n3-nav-item', {
      key: "1-2",
      attrs: {
        "index": "1-3"
      }
    }, [_vm._v("选项3")])], 1), _vm._v(" "), _c('n3-sub-nav', {
      attrs: {
        "index": "1-4"
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("选项4")]), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "1-4-1"
      }
    }, [_vm._v("选项1")])], 2)], 2), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "2"
      }
    }, [_c('n3-icon', {
      attrs: {
        "type": "eye"
      }
    }), _vm._v("导航二")], 1), _vm._v(" "), _c('n3-nav-item', {
      attrs: {
        "index": "3"
      }
    }, [_c('n3-icon', {
      attrs: {
        "type": "cloud"
      }
    }), _vm._v("导航三")], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("n3-nav参数")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Events")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("n3-sub-nav参数")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("n3-nav-item参数")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("n3-nav-group参数")]), _vm._v(" "), _vm._m(5)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":default-active")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"activeIndex\"")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("mode")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"horizontal\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@select")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleSelect\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"1\"")]), _vm._v(">")]), _vm._v("导航一"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-sub-nav")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("template")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"title\"")]), _vm._v(">")]), _vm._v("导航二"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-1\"")]), _vm._v(">")]), _vm._v("选项1"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-2\"")]), _vm._v(">")]), _vm._v("选项2"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"2-3\"")]), _vm._v(">")]), _vm._v("选项3"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-sub-nav")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("index")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"3\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("href")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"#\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("target")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"_blank\"")]), _vm._v(">")]), _vm._v("导航三"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("a")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-nav")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("mode")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("horizontal,vertical")]), _vm._v(" "), _c('td', [_vm._v("vertical")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("theme")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("light,dark")]), _vm._v(" "), _c('td', [_vm._v("light")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-active")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("当前激活菜单的index")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-openeds")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("当前打开的submenu的 key 数组\tArray")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("unique-opened")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("menu-trigger")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("hover")]), _vm._v(" "), _c('td', [_vm._v("子菜单打开的触发方式(只在 mode 为 horizontal 时有效)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("router")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件")]), _vm._v(" "), _c('th', [_vm._v("说明类")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("select")]), _vm._v(" "), _c('td', [_vm._v("菜单激活回调\tindex: 选中菜单项的")]), _vm._v(" "), _c('td', [_vm._v("indexPath: 选中菜单项的 index path")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("open")]), _vm._v(" "), _c('td', [_vm._v("SubMenu 展开的回调")]), _vm._v(" "), _c('td', [_vm._v("index: 打开的 subMenu 的 index， indexPath: 打开的 subMenu 的 index path")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', [_vm._v("SubMenu 收起的回调")]), _vm._v(" "), _c('td', [_vm._v("index: 收起的 subMenu 的 index， indexPath: 收起的 subMenu 的 index path")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("index")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td')])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("index")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("route")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Vue Router 路径对象")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("分组")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4e6b9faa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e6b9faa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3NavDocs.md
// module id = 892
// module chunks = 0